export default __webpack_public_path__ + "static/media/raft.fe1da2dc.png";